"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import type { ArtistPreviewTab } from "@/hooks/useArtistPreviewModal";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Fragment, useEffect } from "react";
import { createPortal } from "react-dom";
import ArtistPreviewAppWrapper from "./ArtistPreviewAppWrapper";
import { ArtistPreviewModalContent } from "./ArtistPreviewModalContent";
export type { ArtistPreviewTab as ModalTab };
interface ArtistPreviewModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly user: ApiProfileMin;
  readonly activeTab: ArtistPreviewTab;
  readonly onTabChange: (tab: ArtistPreviewTab) => void;
}
export const ArtistPreviewModal = t0 => {
  const $ = _c(43);
  const {
    isOpen,
    onClose,
    user,
    activeTab,
    onTabChange
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  const hasTrophyArtworks = getTrophyArtworkCount(user) > 0;
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== isOpen) {
    t1 = () => {
      if (!isOpen || isApp) {
        return;
      }
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    };
    t2 = [isOpen, isApp];
    $[0] = isApp;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  if (isApp) {
    let t3;
    if ($[4] !== activeTab || $[5] !== hasTrophyArtworks || $[6] !== isOpen || $[7] !== onClose || $[8] !== onTabChange || $[9] !== user) {
      t3 = <ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={true} activeTab={activeTab} onTabChange={onTabChange} hasTrophyArtworks={hasTrophyArtworks} />;
      $[4] = activeTab;
      $[5] = hasTrophyArtworks;
      $[6] = isOpen;
      $[7] = onClose;
      $[8] = onTabChange;
      $[9] = user;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] !== isOpen || $[12] !== onClose || $[13] !== t3) {
      t4 = <ArtistPreviewAppWrapper isOpen={isOpen} onClose={onClose}>{t3}</ArtistPreviewAppWrapper>;
      $[11] = isOpen;
      $[12] = onClose;
      $[13] = t3;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  let t3;
  if ($[15] !== onClose) {
    t3 = <TransitionChild as={Fragment} enter="tw-duration-200 tw-ease-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-200 tw-ease-in" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-iron-600/60" onClick={e => {
        e.stopPropagation();
        onClose();
      }} /></TransitionChild>;
    $[15] = onClose;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== onClose) {
    t4 = e_0 => {
      e_0.stopPropagation();
      onClose();
    };
    $[17] = onClose;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== activeTab || $[20] !== hasTrophyArtworks || $[21] !== isOpen || $[22] !== onClose || $[23] !== onTabChange || $[24] !== user) {
    t5 = <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4"><TransitionChild as={Fragment} enter="tw-duration-0" enterFrom="tw-opacity-100" enterTo="tw-opacity-100" leave="tw-duration-0" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-100"><DialogPanel className="tw-relative tw-m-0 tw-max-h-[90vh] tw-w-full tw-max-w-5xl tw-overflow-hidden tw-rounded-xl tw-border tw-border-iron-800 tw-bg-iron-950 tw-p-0 tw-shadow-2xl tw-shadow-black/25" onClick={_temp2}><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={onTabChange} hasTrophyArtworks={hasTrophyArtworks} /></DialogPanel></TransitionChild></div>;
    $[19] = activeTab;
    $[20] = hasTrophyArtworks;
    $[21] = isOpen;
    $[22] = onClose;
    $[23] = onTabChange;
    $[24] = user;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t4 || $[27] !== t5) {
    t6 = <div className="tw-fixed tw-inset-0 tw-z-[100] tw-hidden tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 sm:tw-block" onClick={t4}>{t5}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== activeTab || $[30] !== hasTrophyArtworks || $[31] !== isOpen || $[32] !== onClose || $[33] !== onTabChange || $[34] !== user) {
    t7 = <div className="tw-fixed tw-inset-0 tw-block tw-overflow-hidden sm:tw-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><TransitionChild as={Fragment} enter="tw-transform tw-transition tw-duration-300 tw-ease-out" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-duration-300 tw-ease-in" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-relative tw-max-h-[90vh] tw-w-screen tw-transform-gpu tw-overflow-hidden tw-rounded-t-xl tw-border-t tw-border-iron-800 tw-bg-iron-950 tw-shadow-2xl tw-shadow-black/25 tw-will-change-transform"><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={onTabChange} hasTrophyArtworks={hasTrophyArtworks} /></DialogPanel></TransitionChild></div></div></div>;
    $[29] = activeTab;
    $[30] = hasTrophyArtworks;
    $[31] = isOpen;
    $[32] = onClose;
    $[33] = onTabChange;
    $[34] = user;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== t3 || $[37] !== t6 || $[38] !== t7) {
    t8 = <Dialog as="div" className="tw-relative tw-z-[1000001] tw-cursor-default" onClose={_temp}>{t3}{t6}{t7}</Dialog>;
    $[36] = t3;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
  } else {
    t8 = $[39];
  }
  let t9;
  if ($[40] !== isOpen || $[41] !== t8) {
    t9 = createPortal(<Transition show={isOpen} as={Fragment}>{t8}</Transition>, document.body);
    $[40] = isOpen;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
};
function _temp() {}
function _temp2(e_1) {
  return e_1.stopPropagation();
}